module.exports = __webpack_public_path__ + "static/media/AP_Normal_Z2.5434bdcd.png";